import React from 'react'
import PropTypes from 'prop-types'

import { ButtonGroup } from 'components/ButtonGroup'

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const substring =
  (...args) =>
  (string) =>
    string.substr(...args)

export class DateToggle extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.object.isRequired,
  }

  static defaultProps = {
    onChange: () => {},
    defaultValue: {},
  }

  state = {
    Sunday: !!this.props.defaultValue.Sunday,
    Monday: !!this.props.defaultValue.Monday,
    Tuesday: !!this.props.defaultValue.Tuesday,
    Wednesday: !!this.props.defaultValue.Wednesday,
    Thursday: !!this.props.defaultValue.Thursday,
    Friday: !!this.props.defaultValue.Friday,
    Saturday: !!this.props.defaultValue.Saturday,
  }

  toggleDay(day) {
    this.setState(
      (prevState) => ({
        [day]: !prevState[day],
      }),
      () => {
        document.activeElement.blur()
        this.props.onChange(this.state)
      }
    )
  }

  render() {
    return (
      <ButtonGroup bold widths={7}>
        {days.map((day) => (
          <ButtonGroup.Button
            type="button"
            key={day}
            active={this.state[day]}
            onClick={() => this.toggleDay(day)}
          >
            {substring(0, 3)(day)}
          </ButtonGroup.Button>
        ))}
      </ButtonGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/DateToggle/index.js